import React, { useState } from "react";

export default function HiddenImg({ isHidden, onToggle }) {
  return (
    <div>
      <button
        className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary"
        onClick={onToggle}
      >
        {isHidden
          ? <><i className="uil uil-image"></i> <span>Imagen: Visible</span></>
          : <> <i className="uil uil-image-alt-slash"></i> <span>Imagen: No Visible</span></>
        }
      </button>
    </div>
  );
}

